import React, { useState, useEffect } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import color from "../../../../constants/color";
import Modal from "../../../../components/Modal";


import styles from "./style";
const PayrollEmployeeList = ({ data, handleDelete, payrollData, from, depData, setAllEmp, department }) => {
 
  const navigate = useNavigate()

  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();

  const handleNavigate = (item, payrollData) => {
    navigate("/dashboard/PayrollSalaryList", { state: { item, payrollData } });
  }

  //const combinedData = department === "All" ? [...data, ...depData] ?department === ""?data: data.filter((employee) => employee?.personalInfo?.department === department);
  const combinedData = department === "All"
    ? [...data, ...depData].reduce((acc, emp) => {
      if (
        emp &&
        emp._id &&
        emp.personalInfo?.firstName && // Ensure valid name
        !acc.some(e => e._id === emp._id) // Remove duplicates
      ) {
        acc.push(emp);
      }
      return acc;
    },  [])
    : department === ""
      ? data.filter(emp => emp.personalInfo?.firstName) // Filter only valid first names
      : [...data, ...depData].reduce((acc, emp) => {
        if (
          emp &&
          emp._id &&
          emp.personalInfo?.firstName && // Ensure valid name
          emp.personalInfo?.department === department &&
          !acc.some(e => e._id === emp._id) // Remove duplicates
        ) {
          acc.push(emp);
        }
        return acc;
      }, []);

  const idsAll = combinedData?.map((user) => user?._id);
  useEffect(() => {
    setAllEmp(idsAll);
  }, [setAllEmp]);

  const deleteData = (item) => {
    setValue(item);
    setOpen(true)
  }

  const handleDeleteItem = () => {
    handleDelete(value, "remove");
    setOpen(false);
  };


  return (
    <>


      <TableContainer sx={styles.card} >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Department</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {combinedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              combinedData?.map((item, index) => (

                <TableRow key={index}>

                  <TableCell sx={{ ...styles.tableAlign, ...styles.tableData }}>
                    <Avatar src={item?.personalInfo?.image} sx={{ mr: "8px" }} />
                    <Box >
                      <Typography sx={styles.name}>  {`${item.personalInfo?.firstName} ${item.personalInfo?.surName}`}</Typography>
                      <Typography sx={styles.mail}>{item?.personalInfo?.email}</Typography>
                    </Box>           </TableCell>
                  <TableCell sx={styles.tableData}> <Typography sx={{ ...styles.name, }}>{item?.personalInfo?.department}</Typography></TableCell>
                  <TableCell sx={styles.tableData}>
                    <Box sx={styles.tableIcon}>
                      {/* <EditIcon sx={{ mr: 1 }} onClick={() =>handleEdit(item)} /> */}
                      {from === "Edit" ?
                        <RemoveRedEyeOutlinedIcon sx={{ color: color.lightText, mx: 2 }} onClick={() => { handleNavigate(item, payrollData) }} /> : ""
                      }
                      <DeleteOutlineIcon sx={styles.deleteIcon} onClick={() => deleteData(item?._id)} />
                    </Box></TableCell>
                </TableRow>
              )))}
          </TableBody>

        </Table>

      </TableContainer>


      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Employee"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>);
};
export default PayrollEmployeeList;
